<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="mt-3 pb-3 card shadow-sm">
          <p class="card-header float-left">
            {{ gameInfo.player1Name }} : 得点時打球（サーブを除く）
          </p>
          <bar-chart :chartData="player1ChartData"
            :optionData="optionData" :height="300"/>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="mt-3 pb-3 card shadow-sm">
          <p class="card-header float-left">
            {{ gameInfo.player2Name }} : 得点時打球（サーブを除く）
          </p>
          <bar-chart :chartData="player2ChartData"
            :optionData="optionData" :height="300"/>
      </div>
    </div>
  </div>
</template>

<script>
import CmnConst from '@/lib/cmnConst';
import BarChart from '@/components/atoms/BarChart';

export default {
  name: 'hit-on-score',
  props: ['points', 'labels', 'hitsList', 'gameInfo'],
  components: {
    BarChart,
  },
  data() {
    return {
      CmnConst,
    };
  },
  computed: {
    player1ChartData() {
      const dataSet = this.hitsData[1];
      return {
        labels: this.labelSet,
        datasets: [
          {
            label: '得点時打球',
            backgroundColor: '#82B8D7',
            data: dataSet,
          },
        ],
      };
    },
    player2ChartData() {
      const dataSet = this.hitsData[2];
      return {
        labels: this.labelSet,
        datasets: [
          {
            label: '得点時打球',
            backgroundColor: '#83D7BD',
            data: dataSet,
          },
        ],
      };
    },
    optionData() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      };
    },
    labelSet() {
      const hitsList = CmnConst.hitsStyleList;
      const handList = ['F', 'B'];
      const labelName = [];
      for (let i = 0; i < handList.length; i++) {
        const hand = handList[i];
        for (let j = 0; j < hitsList.length; j++) {
          const hits = hitsList[j];
          labelName.push(`${hand} ${hits}`);
        }
      }
      return labelName;
    },
    hitsData() {
      const labels1 = [];
      const labels2 = [];
      labels1.length = CmnConst.hitsStyleList.length * CmnConst.handList.length;
      labels2.length = CmnConst.hitsStyleList.length * CmnConst.handList.length;
      labels1.fill(0);
      labels2.fill(0);
      for (let i = 0; i < this.points.length; i++) {
        const hits = this.hitsList[i];
        // サービスエースとサーブミスは無視する
        if (this.labels[i] > 1) {
          // プレイヤーに応じて振り分け
          if (this.points[i]) {
            // プレイヤー1
            labels1[
              hits.hitStyle[hits.player.length - 2]
              + (hits.hand[hits.player.length - 2] * CmnConst.hitsStyleList.length)
            ] += 1;
          } else {
            labels2[
              hits.hitStyle[hits.player.length - 2]
              + (hits.hand[hits.player.length - 2] * CmnConst.hitsStyleList.length)
            ] += 1;
          }
        }
      }
      return { 1: labels1, 2: labels2 };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/HitOnScore.vue